import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import axiosInstance from "../AxiosInstance/AxiosInstance";
import DiffEditor from '../ConfigurePages/DiffEditor';
import {
  GET_STUDY_DIFF_DATA,
} from "../../appConstants";
import { toast } from "react-toastify";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {
  const {
    open,
    handleClose,
    currentItem
  } = props;
  const [originalText, setOriginalText] = React.useState('');
  const [anonymizedText, setAnonymizedText] = React.useState('');;

  React.useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            `${GET_STUDY_DIFF_DATA}`,
            {
              "job_id": currentItem.job_id,
              "study_id": currentItem.study_instance_uid,
              "sop_id": currentItem.sop_instance_uid
            },
            { headers: { Authorization: `Bearer ${localStorage.access_token}` } }
          );
          // setStudyData(response?.data?.items || []);
          // setTotalPages(response.data.pages || 1);
          // setTotalData(response.data.total || 0);
          setOriginalText(JSON.stringify(response.data.original_tags, null, " ") || 'No data available');
          setAnonymizedText(JSON.stringify(response.data.anonymized_tags, null, " ")  || 'No data available');
        } catch (error) {
          toast.error(`Error: ${error.message}`, {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        }
      };
      if(currentItem)
        fetchData();
    }, [
      currentItem
    ]);
  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative', backgroundColor: '#1a2c2b'}}>
          <Toolbar>
          <div style={{display: "flex", width: "100%"}}>
    <div id="left-header" style={{width: "55%"}}>Original DICOM Tags</div>
    <div>De-identified DICOM Tags</div>
</div>
            <Button  sx={{float:"right",marginLeft: '20px' }} color="inherit" onClick={handleClose}>
            <CloseIcon />
            </Button>
          </Toolbar>
        </AppBar>
        <DiffEditor originalText={originalText} anonymizedText={anonymizedText}/>
      </Dialog>
    </React.Fragment>
  );
}